import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// [F-MININAV2 T-9] A közös előnézet-overlay váza: háttér (kattintásra zár), kártya, X gomb,
// ESC, valamint a betöltés / nem található / hiba állapotok — a Projektek / Jelöltek / Keresés
// eddigi 3 másolata helyett. A history-kötést (vissza-gesztus) az app adja: az onClose a
// useOverlayHistory által visszaadott close() — így az X / háttér / ESC és a vissza-gesztus
// ugyanazt az állapotot zárja.
import React, { useEffect } from 'react';
import { PreviewSpinner } from './parts';
export function PreviewOverlay({ state, onClose, errorText, notFoundText, children }) {
    // ESC-re zárás
    useEffect(() => {
        const onKey = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [onClose]);
    return (_jsx("div", { className: "pjp-backdrop", onClick: onClose, children: _jsxs("div", { className: "pjp-card", role: "dialog", "aria-modal": "true", onClick: (e) => e.stopPropagation(), children: [_jsx("button", { type: "button", className: "pjp-close", onClick: onClose, "aria-label": "Bez\u00E1r\u00E1s", children: _jsx("i", { className: "fas fa-times", "aria-hidden": "true" }) }), state === 'loading' ? _jsx(PreviewSpinner, {}) : null, state === 'error' ? (_jsxs("div", { className: "pjp-message", children: [_jsx("i", { className: "fas fa-triangle-exclamation", "aria-hidden": "true" }), _jsx("p", { children: errorText })] })) : null, state === 'notfound' ? (_jsxs("div", { className: "pjp-message", children: [_jsx("i", { className: "fas fa-lock", "aria-hidden": "true" }), _jsx("p", { children: notFoundText })] })) : null, state === 'ready' ? children : null] }) }));
}
